<template>

  <SanityImageBackground class="VideoPreview"
    :asset="content.posterImage.asset"
    :style="dimensionsStyle"
    :class="{ isActive }"
  >

    <NonInteractiveVideo v-if="isActive"
      ref="video"
      :videoFile="isActive && content.videoFile"
      class="media"
    />

    <svg viewBox="0 0 280 150" width="280" class="overlay">

      <defs>
        <linearGradient :id="`${content._key}_linearGradient`" x1="133" y1="0" x2="155" y2="106" gradientUnits="userSpaceOnUse">
          <stop stop-color="#2A63A4"/>
          <stop offset="1" stop-color="#0099FF"/>
        </linearGradient>
      </defs>

      <!-- Blue box -->
      <path
        d="M-7 150V5c0-3 3-5 7-5h192c5 0 8 2 13 5l60 42c6 5 7 6 7 11v92c0 4-2 6-7 6H0c-4 0-7-2-7-6Z"
        :fill="`url(#${content._key}_linearGradient)`"
      />

      <!-- Duration -->
      <g transform="translate(15, 22)">
        <path :d="playIconPathD" fill="white" />
        <text x="17" y="11" font-weight="400" font-size="12" fill="white">{{ content.duration }}</text>
      </g>

      <!-- Title -->
      <text font-weight="600" font-size="19" fill="white">
        <tspan v-for="line, index in titleLines" :key="line" x="15" :y="60 + 24 * index">{{ line }}</tspan>
      </text>

    </svg>

  </SanityImageBackground>

</template>

<script>
import { sanityImageUrl } from '~/lib/imageUrls.js'

import NonInteractiveVideo from '../../elems/NonInteractiveVideo.vue'

const maxCharsPerLine = 22

const playIconPathD = [
  'M 6.35,0',
  'A 6.35,6.35 0 0 0 0,6.35 6.35,6.35 0 0 0 6.35,12.7 6.35,6.35 0 0 0 12.7,6.35 6.35,6.35 0 0 0 6.35,0',
  'Z',
  'M 4.3,3.3 9.5,6.35 4.3,9.4',
  'Z',
].join(' ')

export default {
  components: {
    NonInteractiveVideo,
  },
  props: {
    content: Object,
    isActive: Boolean,
    orientation: {
      type: String,
      default: 'landscape',  // or 'portrait'
    },
  },
  inject: ['sanityConfig'],
  data() {
    const size = {
      landscape: { width: 454, height: 254 },
      portrait: { width: 297, height: 528 },
    }[this.orientation]
    return {
      ...size,
      playIconPathD,
    }
  },
  computed: {
    titleLines() {
      // Split title into lines based on number of chars in each line, since
      // SVG doesn't support text wrapping.
      if (this.content.title) {
        const result = []
        const words = this.content.title.split(' ')
        for (const word of words) {
          if (result.length === 0) {
            result.push(word)
          }
          else {
            const last = result.length - 1
            const lineExtended = `${result[last]} ${word}`
            if (lineExtended.length <= maxCharsPerLine) {
              result[last] = lineExtended
            }
            else {
              result.push(word)
            }
          }
        }
        return result
      }
    },
    dimensionsStyle() {
      return {
        width: `${this.width}px`,
        height: `${this.height}px`,
      }
    },
    imageUrl() {
      if (this.content?.posterImage)
        return sanityImageUrl(this.sanityConfig, this.content.posterImage.asset?._ref)
    }
  },
}
</script>

<style scoped>
.VideoPreview {
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  transition: box-shadow 0.15s;
  display: grid;
}
.VideoPreview:before, .VideoPreview > * {
  grid-column: 1;
  grid-row: 1;
}
.VideoPreview::before {
  content: '';
  background-color: #0000004D;
}
.VideoPreview.isActive {
  box-shadow: 0px 4px 24px 0px #0000004D;
}
.VideoPreview.isActive .overlay {
  opacity: 0;
}
.overlay {
  align-self: end;
  transition: opacity 0.15s;
}
</style>
